module.exports = __webpack_public_path__ + "static/media/Cabrio.e16869a9.jpg";